import { EyeFilled } from '@ant-design/icons';
import { Button, Space, Table, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchInput from '../../components/ui/SearchInput';
import { getCustomersWithPagination, syncCustomers } from '../../redux/actions/customers';
import { getRoutes } from '../../routes/Routes';
import { RefreshCcw } from 'lucide-react';

const Customers = () => {
    const navigate = useNavigate();
    const [customers, setCustomers] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 50, totalPages: 0 });
    const [search, setSearch] = useState('');

    const columns = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            width: 100,
        },
        {
            title: 'Name',
            dataIndex: 'title',
            key: 'title',
            width: 250,
        },
        {
            title: 'Email',
            dataIndex: 'invoice_email',
            key: 'invoice_email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'WhatsApp',
            dataIndex: 'invoice_whatsapp_number',
            key: 'invoice_whatsapp_number',
        },
        {
            title: 'Sales Rep',
            dataIndex: 'salesrep',
            key: 'salesrep',
        },
        {
            title: 'Price Level',
            dataIndex: 'price_level',
            key: 'price_level',
        },
        {
            title: 'Terms',
            dataIndex: 'terms',
            key: 'terms',
        },
        {
            title: 'Postcode',
            dataIndex: 'postcode',
            key: 'postcode',
        },
        {
            title: 'Actions',
            key: 'actions',
            align: 'end',
            render: (text, record) => (
                <Space size="small">
                    <Button
                        color="primary"
                        variant="filled"
                        icon={<EyeFilled className="text-lg" />}
                        onClick={() =>
                            navigate(getRoutes().customer_details.route(record.customer_netsuite_id))
                        }
                    />
                </Space>
            ),
        },
    ];

    const getCustomers = async (body) => {
        const res = await getCustomersWithPagination(body);
        console.log("🚀 ~ getCustomers ~ res:", res)
        if (res?.ack) {
            setCustomers(res.customers);
            setPagination((prev) => ({
                ...prev,
                current: body?.page || 1,
                totalPages: Math.ceil(res.total_count / prev.pageSize),
            }));
        }
    };

    const handleSyncCustomers = async () => {
        const res = await syncCustomers();
        if (res?.ack) {
            getCustomers({ searchText: search, page: pagination.current });
        }
    };

    useEffect(() => {
        getCustomers();
    }, []);

    return (
        <div className="customer-page">
            <div className="page-header mb-3">
                <div className="flex justify-content-between align-items-center mb-2">
                    <Typography.Title level={3} className="page-title">
                        Customers
                    </Typography.Title>
                    <Button
                        type="primary"
                        icon={<RefreshCcw size={16} />}
                        onClick={handleSyncCustomers}
                    >
                        Sync Customers
                    </Button>
                </div>

                <div className="flex align-items-center gap-2">
                    <SearchInput
                        maxWidth="25rem"
                        onSearch={(searchText) => {
                            setSearch(searchText);
                            getCustomers({ searchText, page: 1 });
                        }}
                    />
                </div>
            </div>

            <Table
                size="small"
                columns={columns}
                rowKey={(record) => record?.customer_netsuite_id}
                dataSource={customers}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.totalPages * pagination.pageSize,
                    showSizeChanger: false,
                    responsive: true,
                    size: 'large',
                    onChange: (page) => getCustomers({ page, searchText: search }),
                }}
                scroll={{ x: 'max-content', y: 'calc(100vh - 322px)' }}
            />
        </div>
    );
};

export default Customers;
